module.exports = __webpack_public_path__ + "9de784614f3bce979bcc66c808935225.svg";